'use strict';

/*global app*/

/*exported reloadQueuePage */
function reloadQueuePage($countdown) {
  if (!$('.modal:visible').length && app.param('is_allowed_reload_page')) {
    if (app.internetConnectionManager.isOnline()) {
      $countdown.addClass('countdown-pause');
      location.reload();
    }
  }
}
